import api from '../api'

const state = {
  student: undefined,
  notes: []
}

const getters = {
  getPOINote: (state) => (poi) => {
    return state.notes.find(note => note.poi.id === poi.id)
  }
}

const mutations = {
  setStudent (state, student) {
    state.student = student
  },
  setNotes (state, notes) {
    state.notes = notes
  },
  addNote (state, note) {
    state.notes.push(note)
  },
  updateNote (state, newNote) {
    let note = state.notes.find(note => note.poi.id === newNote.poi.id)

    if (note) {
      note.text = newNote.text
    }
  }
}

const actions = {
  getStudentGUID ({ state, commit }) {
    if (state.student !== undefined) {
      return Promise.resolve(state.student)
    } else if (localStorage.student) {
      commit('setStudent', localStorage.student)
      return Promise.resolve(localStorage.student)
    } else {
      return api.createStudent().then((response) => {
        commit('setStudent', response.data.guid)
        localStorage.student = response.data.guid
        return localStorage.student
      })
    }
  },
  getStudentNotes ({ state, commit }) {
    return api.getStudentNotes(state.student).then((response) => {
      commit('setNotes', response.data.notes)
      return response.data.notes
    })
  },
  updateStudentNote ({ state, commit, getters }, { poi, text }) {
    api.updateStudentNote(state.student, poi.id, text).then((response) => {
      let newNote = response.data
      let oldNote = getters.getPOINote(poi)

      if (oldNote) {
        commit('updateNote', newNote)
      } else {
        commit('addNote', newNote)
      }
    })
  },
  trackPOIVisit ({ state }, poiId) {
    api.trackPOIVisit(state.student, poiId)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
